'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const breakpoint = 768;
const useIsMobile = () => {
  const requestRef = React.useRef(0);
  const [width, setWidth] = React.useState(typeof window === 'object' ? window.innerWidth : 0);
  const handleWindowSizeChange = () => setWidth(window.innerWidth);
  React.useEffect(() => {
    requestRef.current = requestAnimationFrame(handleWindowSizeChange);
    return () => cancelAnimationFrame(requestRef.current);
  }, []);
  return width <= breakpoint;
};

exports["default"] = useIsMobile;
